
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["drmicon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.697 1.56L6.707.23.717 1.56a.73.73 0 00-.571.712v7.28c0 1.463.73 2.828 1.948 3.64l4.613 3.075 4.613-3.076a4.373 4.373 0 001.948-3.639v-7.28a.73.73 0 00-.571-.712z","fill":"#0A2144"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.287 5.84h.57c.341 0 .569.228.569.57v4.554c0 .341-.228.569-.57.569H4.165c-.342 0-.57-.228-.57-.57V6.41c0-.342.228-.57.57-.57h.57A2.284 2.284 0 017.01 3.563 2.284 2.284 0 019.287 5.84zM7.01 4.702c-.626 0-1.138.512-1.138 1.138h2.277c0-.626-.512-1.138-1.139-1.138z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.754 10.251L9.426 7.58l-.645-.645-2.253 2.253L5.24 7.9l-.645.645 1.93 1.93.226-.227.003.003z","fill":"#0A2144"}})])
          )
        }
      }
    